import { isAxiosError } from 'axios';

/** The device knows it has no connection, so a request is not even tried. */
export class OfflineError extends Error {
  constructor() {
    super('Offline');
  }
}

/** The request never got an answer from the server: no connection, a timeout, or a dead spot. */
export function isUnreachableError(error: unknown): boolean {
  return error instanceof OfflineError || (isAxiosError(error) && !error.response);
}
